import { Component, Input } from '@angular/core';
import { ClubOverviewService } from '~features/club-overview/club-overview.service';
import { Club, Country } from '~core/models';
import { CountryService } from '~core/services';
import { TooltipTranslationService } from '~shared/translations';

/**
 * Component that displays the products settings in a list
 */
@Component({
  selector: 'app-club-address',
  templateUrl: './club-address.component.html',
  styleUrls: ['../../../pages/club-settings/club.component.scss']
})
export class ClubAddressComponent {
  @Input() public selectedClub: Club;
  @Input() public countries: Array<Country>;

  constructor(
    public clubOverviewService: ClubOverviewService,
    public countryService: CountryService,
    public tooltipTranslations: TooltipTranslationService,
  ) {}

  /**
   * Checks if there is any data inside
   */
  public containsData(): boolean {
    const c = this.selectedClub;
    return  c.street != null ? true :
            c.postCode != null ? true :
            c.city != null ? true :
            c.country != null ? true : false;
  }

  /**
   * Retrieves the country name from country code
   */
  public getCountry(key: any): any {
    return this.countryService.getCountry(key, this.countries);
  }

}
